/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MemberStatistics } from '../../models/member-statistics';

export interface ConsumerStatisticsGet$Params {

/**
 * Number of months to include in statistics (default: 12).
 */
  numberOfMonths?: number;
}

export function consumerStatisticsGet(http: HttpClient, rootUrl: string, params?: ConsumerStatisticsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MemberStatistics>>> {
  const rb = new RequestBuilder(rootUrl, consumerStatisticsGet.PATH, 'get');
  if (params) {
    rb.query('numberOfMonths', params.numberOfMonths, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MemberStatistics>>;
    })
  );
}

consumerStatisticsGet.PATH = '/Consumer/Statistics';
